const ForgotPassword = () => {
  return <>ForgotPassword</>;
};

export default ForgotPassword;
